import { makeStyles } from "@material-ui/core/styles";
import {
  grey300,
  primary,
  secondary,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  tabBar: {
    height: 60,
    borderBottom: `solid 1px ${grey300}`,
  },
  tab: {
    position: "relative",
    marginLeft: theme.spacing(2),
    border: `solid 1px ${grey300}`,
    height: 60,
    padding: `0 ${theme.spacing(2)}px`,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    overflow: "visible",
    cursor: "pointer",
    "& p": {
      height: 60,
      lineHeight: "60px",
    },
    color: secondary,
  },
  activeTab: {
    borderBottom: "1px solid white",
    color: "black",
  },
  activeTabDecoration: {
    position: "absolute",
    top: "calc(100% - 4px)",
    left: "calc(50% - 4px)",
    height: 8,
    width: 8,
    borderRadius: "50%",
    backgroundColor: primary,
  },
  content: {
    paddingTop: theme.spacing(4),
  },
}));

export default useStyles;
